import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import * as sdk from 'pkg/core/sdk';
import type { OrganizationsLocalStorageData } from 'pkg/identity/account';
import * as ls from 'pkg/local_storage';

import { setApiToken } from 'core/api_auth';

export const saveAppleSignInCredentials = async (
	payload: Record<string, string>
): Promise<boolean> => {
	const response = await sdk.post(
		endpoints.Auth.AppleSignInSave(),
		{},
		payload
	);
	return response.ok;
};

export async function createOneTimeLoginToken(
	accountId: number
): Promise<string> {
	const request = await sdk.post(
		endpoints.AccountTokens.CreateOneTimeLogin(accountId)
	);
	if (!request.ok) {
		return '';
	}

	const response = await request.json();
	if (response.token) {
		return response.token;
	}

	return '';
}

export interface AuthOptions {
	organizationName: string;
	profileImageUrl: string;
	primaryColor: string;
	organizationId: number;
	organizationSlug: string;
	identityProviders: models.identityProvider.IdentityProvider[];
}

export async function fetchAuthOptions(
	slug: string
): Promise<[boolean, AuthOptions]> {
	const request = await sdk.get(endpoints.Auth.Options(slug), {}, { slug });

	if (request.ok) {
		const json = await request.json();

		return [true, json];
	}

	return [false, null];
}

export function updateAuthToken(
	tokens: {
		accountToken: string;
		orgToken?: string;
	},
	organizationId?: number
) {
	const lsOrganizations =
		ls.getJsonItem<OrganizationsLocalStorageData>(
			ls.LocalStorageKeys.Organizations
		) || {};

	let token = '';

	if (tokens.orgToken) {
		token = tokens.orgToken;

		if (organizationId) {
			if (Object.keys(lsOrganizations).length === 0) {
				lsOrganizations[organizationId] = {
					orgToken: tokens.orgToken,
					activeMembership: null,
				};
			} else {
				lsOrganizations[organizationId].orgToken = tokens.orgToken;
			}
		}
	}

	if (tokens.accountToken && !tokens.orgToken) {
		token = tokens.accountToken;
	}

	ls.setJsonItem(ls.LocalStorageKeys.Organizations, lsOrganizations);
	ls.setItem(ls.LocalStorageKeys.AuthToken, tokens.accountToken);
	setApiToken(token);
}
